/**
 * Project: bicc-ffvt-website-ui
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2022-03-11 17:03:02
 * License: MIT License
 */

import { get } from 'lodash'
import translations from './resources/translations.json'

const baseUrl = (typeof APP_BASE_URL === 'undefined') ? "/" : APP_BASE_URL
const assetBaseUrl = (typeof APP_ASSET_PATH === 'undefined') ? "/" : APP_ASSET_PATH
const apiBaseUrl = (typeof APP_API_URL === 'undefined') ? "/api/v1/" : APP_API_URL
const dataBaseUrl = (typeof APP_DATA_URL === 'undefined') ? "/data/" : APP_DATA_URL

const lang = document.documentElement.lang || 'de'


/**
 * @param {String} path
 * @returns String
 */
export function basePath(path) {
    const prefix = baseUrl.replace(/\/$/g, '')
    return path.startsWith('/') ? path : prefix + '/' + path
}

/**
 * @param {String} path
 * @returns String
 */
export function assetPath(path) {
    return path.startsWith('/') ? path : assetBaseUrl + '/' + path
}

export function apiUrl(path) {
    return new URL(path, new URL(apiBaseUrl, document.location))
}

export function dataUrl(path, search = null) {
    const url = new URL(path, new URL(dataBaseUrl, document.location))
    if (search) {
        url.search = (search instanceof URLSearchParams) ? search : new URLSearchParams(search)
    }
    return url
}


export function currentLang() {
    return lang
}

/**
 *
 */
export function trans(path) {
    return get(translations[lang] ?? {}, path, '[' + path + ']')
}


export function isDev() {
    return (process.env.NODE_ENV == 'development')
}
